var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"header_img",staticStyle:{"width":"100%","object-fit":"contain"},attrs:{"src":require("@/assets/msbsde_header.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }